export const styles = {
  container:
    "bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-800 rounded-lg p-3 sm:p-4 relative before:absolute before:left-0 before:right-0 before:top-[50px] sm:before:top-[60px] before:h-[1px] before:bg-gray-100 dark:before:bg-gray-700",

  header: "px-0 py-2",

  title:
    "pb-2 text-base sm:text-xl font-semibold text-gray-800 dark:text-white/90",

  formContainer:
    "bg-white dark:bg-gray-800 rounded-lg mt-2 sm:mt-4 overflow-visible",

  form: "grid grid-cols-1 gap-2 sm:gap-4 items-start p-2",

  opportunitieDetails:
    "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-4",

  label:
    "text-xs sm:text-sm font-medium text-gray-800 dark:text-white/90 mb-1 block",

  labelmain:
    "text-theme-xm sm:text-theme-xm font-medium text-gray-800 dark:text-white/90 font-semibold",

  inputField:
    "h-8 sm:h-10 w-full rounded-lg border appearance-none px-2 sm:px-3 py-1 sm:py-2 text-xs sm:text-sm shadow-theme-xs placeholder:text-gray-400 focus:outline-none focus:ring dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 bg-transparent text-gray-800 border-gray-300 dark:border-gray-600 focus:border-brand-300 dark:focus:border-brand-800 focus:ring-brand-500/10",

  inputError:
    "border-red-400 ring-2 ring-red-500/10 dark:border-red-400 dark:ring-2 dark:ring-red-500/10",

  inputDefault:
    "border-gray-300 dark:border-gray-600 focus:border-brand-300 dark:focus:border-brand-800 focus:ring focus:ring-brand-500/10",

  errorText: "text-red-500 dark:text-red-400 text-xs mt-0.5 inline-block",

  buttonsContainer:
    "p-2 rounded-b flex flex-col sm:flex-row justify-end gap-2 w-full",

  submitButton:
    "px-8 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm bg-[#2f6aa7] dark:bg-[#3d6794] text-white rounded-lg hover:bg-[#2779bd] dark:hover:bg-[#335877] w-full sm:w-auto disabled:opacity-50",

  cancelButton:
    "px-4 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm bg-white text-gray-700 ring-1 ring-gray-300 rounded-lg hover:bg-gray-50 dark:bg-gray-900 dark:text-gray-300 dark:ring-gray-600 dark:hover:bg-gray-600 w-full sm:w-auto",

  required: "text-error-500 dark:text-red-400",

  modal:
    "w-[90%] max-w-[400px] sm:max-w-[600px] bg-white dark:bg-gray-900 px-3 sm:px-6 py-4 sm:py-6 rounded-lg shadow-xl mx-auto text-center relative",

  modalCloseButton:
    "absolute top-1.5 sm:top-2 right-1.5 sm:right-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200",

  modalIconContainer:
    "w-10 sm:w-12 h-10 sm:h-12 flex items-center justify-center bg-green-100 dark:bg-green-900 text-green-600 dark:text-green-400 rounded-full mx-auto",

  modalTitle:
    "text-sm sm:text-lg font-bold text-gray-800 dark:text-white mt-2 sm:mt-3",

  modalMessage:
    "text-xs sm:text-sm text-gray-500 dark:text-gray-400 mt-1 sm:mt-2",

  modalButtonContainer:
    "mt-3 sm:mt-4 flex flex-col sm:flex-row justify-center gap-2 sm:gap-3",

  modalButton:
    "px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm bg-green-600 text-white rounded-md hover:bg-green-700 dark:bg-green-700 dark:hover:bg-green-600 w-full sm:w-auto",

  textareaField:
    "w-full rounded-lg border appearance-none px-2 sm:px-3 py-1.5 sm:py-2 text-xs sm:text-sm shadow-theme-xs placeholder:text-gray-400 focus:outline-none focus:ring dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 bg-transparent text-gray-800 border-gray-300 dark:border-gray-600 focus:border-brand-300 dark:focus:border-brand-800 focus:ring-brand-500/10",

  // Ensures dropdown overlays correctly on mobile
  dropdownMenu: "z-[9999] relative",
};
